<template>
  <v-dialog fullscreen :value="value" v-on:input="$emit('input', $event)">
    <v-card>
      <v-toolbar extended extension-height="2">
        <v-btn icon v-on:click="close">
          <v-icon>arrow_back</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text text--darken-4">Choose image for "{{ suggest }}"</v-toolbar-title>

        <v-spacer></v-spacer>

        <UploadButton v-on:file="upload"></UploadButton>

        <v-progress-linear :active="isLoading" slot="extension" height="2" :indeterminate="true" class="ma-0"></v-progress-linear>
      </v-toolbar>
      <v-container>
        <v-layout>
        <v-flex xs4>
          <v-text-field
                  v-model="search"
                  append-outer-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  @click:append-outer="debouncedSearchImage"
                  @focus="focused = true" @blur="focused = false"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 style="padding-left: 12px; padding-right: 12px;">
          <v-radio-group v-model="provider" row>
            <v-radio v-for="prov in providers" :key="prov" :label="prov" :value="prov"></v-radio>
          </v-radio-group>
        </v-flex>
          <v-flex xs3>
            <v-text-field
                    v-model="directUrl"
                    label="Direct URL"
                    append-outer-icon="mdi-send"
                    single-line
                    hide-details
                    type="url"
                    :rules="[ruleUrl]"
                    @click:append-outer="setDirectUrl"
            ></v-text-field>
          </v-flex>
        <v-alert :value="noResult" type="info">No result</v-alert>
        </v-layout>
      </v-container>
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-item-group>
              <v-item
                      v-for="image in images"
                      :key="image.id"
              >
                <img :src="image.previewURL" v-on:click="select(image.largeImageURL, image.metadata)" class="image-item" @contextmenu="openFullImage(image.largeImageURL)" />
              </v-item>
            </v-item-group>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex offs v-if="showMoreBtn" class="text-xs-center" style="margin: 16px;">
          <v-btn color="primary" v-on:click="loadMore" :disabled="isLoadingMore">Load more</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import ImageProvider from '../common/ImageProvider'
import debounce from 'lodash/debounce'
import { StorageApi } from '../common/api'
import UploadButton from './UploadButton'

export default {
  components: { UploadButton },
  props: ['value', 'suggest'],
  data () {
    return {
      isLoading: false,
      isLoadingMore: false,
      noResult: false,
      focused: false,
      page: 1,
      search: '',
      provider: ImageProvider.list[0],
      images: [],
      totalImages: 0,
      providers: ImageProvider.list,
      directUrl: ''
    }
  },
  computed: {
    showMoreBtn () {
      return this.images.length < this.totalImages
    }
  },
  watch: {
    value () {
      if (this.value) {
        // this.debouncedSearchImage()
      } else {
        this.images = []
        this.search = this.suggest
        this.totalImages = 0
        this.directUrl = ''
      }
    },
    suggest () {
      this.search = this.suggest
    },
    search () {
      if (this.focused) {
        this.debouncedSearchImage()
      }
    },
    provider () {
      this.images = []
      this.totalImages = 0
      this.debouncedSearchImage()
    }
  },
  created () {
    this.debouncedSearchImage = debounce(this.searchImages, 800)
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    async select (image, metadata) {
      this.isLoading = true
      try {
        const { data } = await StorageApi.copy('image', image, this.suggest, metadata)
        this.$emit('select', data.url)
        this.close()
      } catch (e) {
        alert('Ошибка при загрузке картинки на сервер')
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    async upload ({ file, name }) {
      this.isLoading = true
      try {
        const { data } = await StorageApi.upload('image', name, file, this.suggest)
        this.$emit('select', data.url)
        this.close()
      } catch (e) {
        alert('Ошибка при загрузке картинки на сервер')
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    async loadMore () {
      if (this.isLoadingMore) {
        return
      }
      this.page++
      this.isLoadingMore = true
      try {
        await this.searchImages(this.page)
      } finally {
        this.isLoadingMore = false
      }
    },
    async searchImages (page = 1) {
      if (!this.value) {
        return
      }
      if (this.search === '') {
        this.images = []
        return
      }
      this.page = page
      this.isLoading = true
      this.noResult = false
      try {
        const requestedSearch = this.search
        const { images, totalImages } = await ImageProvider.search(this.provider, requestedSearch, { page })

        if (requestedSearch !== this.search) {
          console.log(`Search with key "${requestedSearch}" is outdated`)
          return
        }
        if (page === 1) {
          this.images = images
        } else {
          this.images = [...this.images, ...images]
        }

        this.totalImages = totalImages
        if (this.images.length === 0) {
          this.noResult = true
        }
      } catch (e) {
        alert('Ошибка при получении данных из pixabay')
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    openFullImage (url) {
      console.log('Open window', url)
      window.open(url)
    },
    setDirectUrl () {
      if (!this.directUrl) {
        return
      }

      if (!this.directUrl.match(/^https:\/\//)) {
        return
      }

      this.$emit('select', this.directUrl)
      this.close()
    },
    ruleUrl (value) {
      if (!this.directUrl) {
        return true
      }

      return !!this.directUrl.match(/^https:\/\//) || 'Invalid URL'
    }
  }
}
</script>

<style scoped>
  .image-item {
    max-height: 180px;
    margin-left: 6px;
    margin-top: 6px;
    border: 2px solid white;
  }
  .image-item:hover {
    border: 2px solid #2196F3;
  }
  .v-toolbar__extension {
    padding: 0;
  }
</style>
